import * as yup from "yup";

import type { Translate } from "@shared/i18n/translationKey";

const regexText = /^([a-zA-Z ]+)$/;

/**
 * Fábrica de schema de validación para el formulario de actualización de perfil.
 * Se construye una vez por render de componente (pasando `t` estable), no inline
 * en el body del hook, para que yup no reconstruya el schema en cada render.
 *
 * @param {Function} t - Función de traducción de react-i18next.
 * @returns {yup.ObjectSchema}
 */
export const buildUpdateProfileSchema = (t: Translate) =>
    yup.object().shape({
        firstName: yup
            .string()
            .required(t("isRequired"))
            .max(30, t("lengthMustNotBeMoreThan30Characters"))
            .min(2, t("lengthMustNotBeGreaterThan2Characters"))
            .matches(regexText, t("itMustContainTextOnly")),
        lastName: yup
            .string()
            .required(t("isRequired"))
            .max(30, t("lengthMustNotBeMoreThan30Characters"))
            .min(2, t("lengthMustNotBeGreaterThan2Characters"))
            .matches(regexText, t("itMustContainTextOnly")),
        email: yup.string().email(t("validEmailMessage")).required(t("isRequired")),
        companyEmail: yup.string().email(t("validEmailMessage")).required(t("isRequired")),
        dateOfBirth: yup.date().typeError(t("isRequired")).required(t("isRequired")),
        country: yup.string().required(t("isRequired")),
        nationality: yup.string().required(t("isRequired")),
        gender: yup.string().required(t("isRequired")),
        areaCode: yup
            .string()
            .required(t("isRequired"))
            .max(4, t("lengthMustNotBeMoreThan4Characters"))
            .min(1, t("lengthMustNotBeGreaterThan2Characters")),
        phoneNumber: yup
            .string()
            .required(t("isRequired"))
            .max(11, t("lengthMustNotBeMoreThan11Characters"))
            .min(1, t("lengthMustNotBeGreaterThan2Characters")),
        passportNumber: yup.string().required(t("isRequired")),
        postalCode: yup
            .string()
            .required(t("isRequired"))
            .max(5, t("lengthMustNotBeMoreThan5Characters"))
            .min(1, t("lengthMustNotBeGreaterThan2Characters")),
        address: yup.string().required(t("isRequired")),
        nameEmergencyContact: yup.string().required(t("isRequired")),
        relationshipEmergencyContact: yup.string().required(t("isRequired")),
        areaCodeEmergencyContact: yup
            .string()
            .required(t("isRequired"))
            .max(4, t("lengthMustNotBeMoreThan4Characters"))
            .min(1, t("lengthMustNotBeGreaterThan2Characters")),
        phoneNumberEmergencyContact: yup
            .string()
            .required(t("isRequired"))
            .max(11, t("lengthMustNotBeMoreThan11Characters"))
            .min(1, t("lengthMustNotBeGreaterThan2Characters")),
    }).required();
